export default "__VITE_ASSET__DJ5ML$aT__"